/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateRepeatingTaskInput = {
    globalTaskId?: string | null | undefined;
    repeatType?: string | null | undefined;
    monday?: boolean | null | undefined;
    tuesday?: boolean | null | undefined;
    wednesday?: boolean | null | undefined;
    thursday?: boolean | null | undefined;
    friday?: boolean | null | undefined;
    saturday?: boolean | null | undefined;
    sunday?: boolean | null | undefined;
    monthlyDay?: number | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createRepeatingTaskMutationVariables = {
    input: CreateRepeatingTaskInput;
};
export type createRepeatingTaskMutationResponse = {
    readonly createRepeatingTask: {
        readonly task: {
            readonly repeatingTask: {
                readonly id: string;
                readonly repeatType: string | null;
                readonly monday: boolean | null;
                readonly tuesday: boolean | null;
                readonly wednesday: boolean | null;
                readonly thursday: boolean | null;
                readonly friday: boolean | null;
                readonly saturday: boolean | null;
                readonly sunday: boolean | null;
                readonly monthlyDay: number | null;
            } | null;
        } | null;
    } | null;
};
export type createRepeatingTaskMutation = {
    readonly response: createRepeatingTaskMutationResponse;
    readonly variables: createRepeatingTaskMutationVariables;
};



/*
mutation createRepeatingTaskMutation(
  $input: CreateRepeatingTaskInput!
) {
  createRepeatingTask(input: $input) {
    task {
      repeatingTask {
        id
        repeatType
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        monthlyDay
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateRepeatingTaskInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "RepeatingTask",
  "kind": "LinkedField",
  "name": "repeatingTask",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repeatType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "monday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tuesday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wednesday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thursday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "friday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "saturday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sunday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "monthlyDay",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createRepeatingTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateRepeatingTaskPayload",
        "kind": "LinkedField",
        "name": "createRepeatingTask",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createRepeatingTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateRepeatingTaskPayload",
        "kind": "LinkedField",
        "name": "createRepeatingTask",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createRepeatingTaskMutation",
    "operationKind": "mutation",
    "text": "mutation createRepeatingTaskMutation(\n  $input: CreateRepeatingTaskInput!\n) {\n  createRepeatingTask(input: $input) {\n    task {\n      repeatingTask {\n        id\n        repeatType\n        monday\n        tuesday\n        wednesday\n        thursday\n        friday\n        saturday\n        sunday\n        monthlyDay\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'a0139266e9552daa10beebeea97ea02d';
export default node;
